import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiBook, FiEye } = FiIcons;

const Logo = () => {
  return (
    <motion.div 
      className="relative w-10 h-10"
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg shadow-lg">
        <div className="flex items-center justify-center w-full h-full">
          <div className="relative">
            <SafeIcon icon={FiShield} className="w-6 h-6 text-white" />
            <motion.div
              className="absolute -top-1 -right-1"
              animate={{ 
                scale: [1, 1.2, 1],
                rotate: [0, 10, 0]
              }}
              transition={{ 
                duration: 2,
                repeat: Infinity,
                repeatType: "reverse"
              }}
            >
              <SafeIcon icon={FiEye} className="w-3 h-3 text-yellow-300" />
            </motion.div>
          </div>
        </div>
      </div>
      <motion.div
        className="absolute inset-0 bg-gradient-to-br from-indigo-400 to-purple-500 rounded-lg"
        animate={{ 
          opacity: [0.7, 1, 0.7],
        }}
        transition={{ 
          duration: 3,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      />
    </motion.div>
  );
};

export default Logo;